<div class="resume_historique">
  <div class="resume_texte">
    <p class="titre_resume">Historique des modifications</p>

    @if (derniereModification(); as derniere) {
      <p class="derniere_modification">
        Dernière modification le
        <strong>{{ derniere.dateAction | date: 'dd/MM/yyyy' }}</strong>
        à
        <strong>{{ derniere.dateAction | date: 'HH:mm:ss' }}</strong>
        sur
        <strong>{{ libelleClient(derniere.identifiantClient) }}</strong>
        <span class="compteur">({{ nombreModifications() }} au total)</span>
      </p>
    } @else if (!chargementEnCours()) {
      <p class="derniere_modification">Aucune modification enregistrée pour l'instant.</p>
    }
  </div>

  <button
    type="button"
    appButton
    variant="ghost"
    iconOnly
    icon="external"
    label="Ouvrir l'historique complet"
    appTooltip="Ouvrir l'historique complet"
    (click)="ouvrir()"
  ></button>
</div>
